/**
 * Os rótulos do formulário de registro.
 *
 * **Ficam aqui, e não no glossário, pela regra do próprio glossário**: ele existe para o texto que
 * aparece em mais de uma tela — é ele que evita "Ordem de serviço" numa e "OS" noutra. Estes só
 * existem neste formulário. É o mesmo critério de `relatorios/trp/textoDoTrp.ts`.
 *
 * Os rótulos seguem o modelo do contrato, e não a coluna do banco: quem preenche está com o papel
 * do ANEXO IA ou IB na frente, e "Objetivo da Ordem de Serviço" é o que está escrito lá.
 */
export const FORMULARIO = {
  titulo: 'Registrar ordem de serviço',
  ajuda:
    'Registre a ordem como ela foi assinada. O sistema não corrige o documento: ele guarda o que está ' +
    'escrito e mostra a conferência ao lado, quando as contas do papel e as do sistema não coincidem.',
  semRascunho:
    'Não há rascunho: a ordem é registrada de uma vez. Se algo estiver errado depois, ela é revogada — ' +
    'com quem revogou, quando e por quê — e a correta é registrada ao lado.',
  enviar: 'Registrar a ordem de serviço',
  cancelar: 'Cancelar',
  semAcesso: {
    titulo: 'Só a fiscalização registra ordem de serviço',
    ajuda:
      'Emitir e revogar ordem de serviço é ato da Prefeitura. As ordens continuam visíveis para os dois ' +
      'lados do contrato: elas obrigam a contratada, e esconder a ordem de quem ela obriga seria esconder ' +
      'a obrigação.',
  },

  secoes: {
    documento: 'O documento',
    contratado: 'O que foi contratado',
    pedido: 'O que esta ordem pede',
    assinaturas: 'Quem assina',
    itens: 'Linhas de serviço',
  },

  numeroExterno: 'Número no documento',
  regime: 'Modelo da ordem',
  tipo: 'Fase (ordem de projeto)',
  tipoAjuda: 'Inicial e Final são as Fases 1 e 2 do ANEXO V. Só existem na ordem medida em Pontos de Função.',
  ordemInicial: 'Número da ordem Inicial que esta conclui',
  competencia: 'Mês da ordem',
  competenciaAjuda:
    'Só na ordem mensal. A ordem de projeto atravessa meses e não pertence a nenhum — um mês nela a faria ' +
    'entrar na apuração do mês errado.',
  periodoInicio: 'Início do período',
  periodoFim: 'Fim do período',
  emitidaEm: 'Data de emissão',
  contrato: 'Contrato',
  objeto: 'Objeto contratado',
  objetivo: 'Objetivo desta ordem',
  requisitosNaoFuncionais: 'Requisitos não funcionais',
  artefatosFornecidos: 'Artefatos fornecidos',
  artefatosAGerar: 'Artefatos a gerar',
  unidade: 'Unidade requisitante',
  solicitanteNome: 'Quem pediu',
  solicitanteEmail: 'E-mail de quem pediu',
  fiscalNome: 'Fiscal requisitante',
  fiscalMatricula: 'Matrícula do fiscal requisitante',
  fiscalAssinouEm: 'Data da assinatura do fiscal requisitante',
  gestorNome: 'Gestor do contrato',
  gestorMatricula: 'Matrícula do gestor',
  gestorAssinouEm: 'Data da assinatura do gestor',
  valorTotal: 'Valor total estimado da ordem',
  valorTotalAjuda:
    'O valor do rodapé do documento, como está escrito. O sistema soma as linhas ao lado e mostra as duas ' +
    'contas quando elas não coincidem — sem corrigir nenhuma.',

  item: {
    numero: 'Item',
    descricao: 'Serviço',
    metrica: 'Unidade de medição',
    unidade: 'Unidade escrita na linha',
    unidadeAjuda: 'Como o documento a escreve. As praticadas aparecem ao clicar; outra pode ser digitada.',
    catser: 'CATSER',
    valorUnitario: 'Valor unitário',
    numerador: 'Quantidade (de cima)',
    denominador: 'Quantidade (de baixo)',
    fracaoAjuda:
      'A quantidade é uma fração, como o documento a escreve: 25/30 são 25 dias de um mês contado como 30. ' +
      'Quantidade inteira usa 1 embaixo.',
    valorTotal: 'Valor total da linha',
    valorTotalAjuda: 'Como está no documento. O sistema não o recalcula nem o corrige.',
    adicionar: 'Adicionar linha',
    remover: 'Remover esta linha',
    titulo: (posicao: number) => `Linha ${posicao}`,
  },
} as const
